module.exports = __webpack_public_path__ + "static/media/start-carousel-discuss.5ef55b3c.jpg";